import { FILTERS_GROUP } from "../constants";

export const DEFAULT_SELECTED_FILTER_ITEM = FILTERS_GROUP[1].items[0]?.id;
